import classNames from 'classnames';
import { useCallback } from 'react';

import Button from './Button';

import styles from '../../../styles/buttons/toggles.module.css';

interface ToggleOption {
    value: string | number;
    label: React.ReactNode;
    children?: React.ReactNode;
    className?: string;
    [key: string]: unknown;
}

interface TogglesProps {
    options: ToggleOption[];
    value?: string | number | null;
    isGrouped?: boolean;
    className?: string | null;
    itemsClassName?: string | null;
    itemClassName?: string | null;
    buttonClassName?: string | null;
    currentClassName?: string | null;
    onChange?: ((value: string | number) => void) | null;
}

function Toggles({
    options,
    value = null,
    isGrouped = false,
    className = null,
    itemsClassName = null,
    itemClassName = null,
    buttonClassName = null,
    currentClassName = null,
    onChange = null,
}: TogglesProps) {
    const onClickButton = useCallback(
        (e: React.MouseEvent<HTMLButtonElement | HTMLAnchorElement>, choice: ToggleOption) => {
            const newValue = choice.value ? choice.value : value;
            if (onChange !== null && newValue !== null) {
                onChange(newValue);
            }
        },
        [value, onChange],
    );

    return (
        <div
            className={classNames([
                styles.container,
                {
                    [styles.isGrouped]: isGrouped,
                    [className]: className !== null,
                },
            ])}
        >
            <ul
                className={classNames([
                    styles.items,
                    {
                        [itemsClassName]: itemsClassName !== null,
                    },
                ])}
            >
                {(options || []).map((it, idx) => {
                    const {
                        value: optionValue,
                        label = null,
                        children = null,
                        className: optionClassName = null,
                        ...buttonProps
                    } = it || {};
                    return (
                        <li
                            className={classNames([
                                styles.item,
                                {
                                    [itemClassName]: itemClassName !== null,
                                    [optionClassName]: optionClassName !== null,
                                },
                            ])}
                            key={`option-${optionValue}-${idx + 1}`}
                        >
                            <Button
                                {...buttonProps}
                                className={classNames([
                                    styles.button,
                                    {
                                        [styles.current]: optionValue === value,
                                        [buttonClassName]: buttonClassName !== null,
                                        [currentClassName]:
                                            currentClassName !== null && optionValue === value,
                                    },
                                ])}
                                onClick={(e) => onClickButton(e, it)}
                            >
                                {label}
                            </Button>
                            {children}
                        </li>
                    );
                })}
            </ul>
        </div>
    );
}

export default Toggles;
